// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"ChargingMethods_thecomp___Ontk"};